import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../styles/Team.css";

const Team = () => {
  return (
    <>
      {/* Full-width heading */}
      <h2 id="team" className="text-center bg-dark text-light my-4 py-4 w-100">
        Our Team
      </h2>
    <section className="team-section py-5">
      <Container>
        <Row className="align-items-center">
          {/* Left Side (Heading & Text) */}
          <Col lg={6} className="text-content">
            <h2 className="team-heading">Our Dedicated Management and Team</h2>
            <p className="team-text">
              Our team at Bhanot International LLC is committed to excellence and innovation. We bring together experienced professionals who work passionately to drive success.
              At Bhanot International LLC, our dedicated management and team form the backbone of our success. Our leadership fosters a collaborative environment where innovation thrives, and every team member is empowered to make a meaningful impact.We believe in integrity, efficiency, and customer-centric solutions, ensuring that our partners receive unparalleled service and support. By combining strategic vision with hands-on execution, we navigate challenges, drive growth, and uphold the highest standards in the industry.
            </p>
          </Col>

          {/* Right Side (Image) */}
          <Col lg={6} className="image-content">
            <img src="/team.jpeg" alt="Our Team" className="img-fluid team-image" />
          </Col>
        </Row>
      </Container>
    </section>
    </>
  );
};

export default Team;
